module.exports = __webpack_public_path__ + "static/media/FiraSans-Medium.9e18cebd.ttf";